var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFaqIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_247_61",
    "data-name": "Component 247 \\u2013 61",
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 46,
    viewBox: "0 0 57 46",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2299",
    "data-name": "Rectangle 2299",
    width: 57,
    height: 46,
    rx: 8.179,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1184",
    "data-name": "Group 1184",
    transform: "translate(10.039 7.279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M260.525,319.661H254.5v7.8h4.04v4.484H254.5v12.93h-4.363v-29.7h10.384Z",
    transform: "translate(-250.141 -314.853)",
    fill: "#383f50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M257.723,344.874l4.485-29.7h5.332l4.486,29.7h-4.242l-.809-6.06h-4.2l-.808,6.06Zm7.394-20.041-.122-.767h-.241l-.122.767-1.254,9.375h2.991Z",
    transform: "translate(-247.777 -314.853)",
    fill: "#383f50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M281.594,338.85a8.167,8.167,0,0,1-.889,3.6,2.683,2.683,0,0,0,1.737,1.052v3.717a4.764,4.764,0,0,1-4.484-2.3,6.843,6.843,0,0,1-2.181.363,5.309,5.309,0,0,1-3.395-1.01,5.442,5.442,0,0,1-1.7-2.181,8.066,8.066,0,0,1-.728-3.232V321.355a8.034,8.034,0,0,1,.728-3.193,5.12,5.12,0,0,1,5.091-3.232,5.429,5.429,0,0,1,3.353,1.01,5.691,5.691,0,0,1,1.737,2.222,8.035,8.035,0,0,1,.728,3.193Zm-4.363-17.495a2.685,2.685,0,0,0-.567-1.859,1.256,1.256,0,0,0-.888-.324,1.349,1.349,0,0,0-1.293,1.091,3.084,3.084,0,0,0-.163,1.091V338.85a2.569,2.569,0,0,0,.607,1.859,1.158,1.158,0,0,0,.849.323,1.279,1.279,0,0,0,1.293-1.091,2.857,2.857,0,0,0,.161-1.09Z",
    transform: "translate(-243.963 -314.93)",
    fill: "#383f50"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFaqIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/faq-icon.4ee26b270a501cb92e66224485fd6c9a.svg";